import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=a340165c&scoped=true&"
var script = {}
import style0 from "./Logout.vue?vue&type=style&index=0&id=a340165c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a340165c",
  null
  
)

export default component.exports